import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1468.29412,0 L1468.29412,112.941176 L282.411765,112.941176 C251.208324,112.941176 225.941176,138.190874 225.941176,169.411765 L225.941176,169.411765 L225.941176,1750.58824 C225.941176,1781.80913 251.208324,1807.05882 282.411765,1807.05882 L282.411765,1807.05882 L1468.29412,1807.05882 L1468.29412,1920 L282.411765,1920 C188.850095,1920 113,1844.20229 113,1750.58824 L113,1750.58824 L113,169.411765 C113,75.7977119 188.850095,0 282.411765,0 L282.411765,0 L1468.29412,0 Z M1807.11765,0 L1807.11765,1920 L1694.17647,1920 L1694.17647,0 L1807.11765,0 Z M863.657499,581.245735 L943.518971,661.107206 L701.096,903.529 L1355.35294,903.529412 L1355.35294,1016.47059 L701.097,1016.47 L943.518971,1258.89279 L863.657499,1338.75427 L484.903234,960 L863.657499,581.245735 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconExpandLeftLine = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandLeftLine, _Component);

  var _super = _createSuper(IconExpandLeftLine);

  function IconExpandLeftLine() {
    _classCallCheck(this, IconExpandLeftLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandLeftLine, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconExpandLeftLine /> is deprecated. Please use <IconExpandStartLine /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExpandLeftLine.displayName = "IconExpandLeftLine";
  return IconExpandLeftLine;
}(Component);

IconExpandLeftLine.glyphName = 'expand-left';
IconExpandLeftLine.variant = 'Line';
IconExpandLeftLine.deprecated = true;
IconExpandLeftLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandLeftLine;
export { IconExpandLeftLine };